export const piezas = []



// WEBPACK FOOTER //
// ./src/store/data.js